export default __webpack_public_path__ + "static/media/ket-noi-that-bai.387c0ff4.png";